import { gql } from '@apollo/client';
import { questionnaireFragment } from '@legalosApi/graphql/fragments/fragments';

export const QUESTIONNAIRE_DOC = gql`
  ${questionnaireFragment}
  query questionnaireDoc($input: QuestionnaireInput) {
    questionnaire(input: $input) {
      ...QuestionnaireFragment
      document
      styles
    }
  }
`;
